(() => {
  const WRAP = "[data-rim-colour]";
  const MAP = "[data-rim-colour-map]";
  const HEADING = "[data-rim-colour-heading]";

  let lastVariantId = null;

  function getVariantIdFromUrl() {
    const v = new URLSearchParams(window.location.search).get("variant");
    return v ? String(v) : null;
  }

  function getVariantIdFromForms() {
    // Works for both main form + sticky ATC if they keep inputs in sync.
    const inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (const el of inputs) {
      if (el && el.value) return String(el.value);
    }
    return null;
  }

  function applyVariantId(variantId) {
    if (!variantId) return;

    document.querySelectorAll(WRAP).forEach((wrap) => {
      const mapEl = wrap.querySelector(MAP);
      const headingEl = wrap.querySelector(HEADING);
      if (!mapEl || !headingEl) return;

      let map = {};
      try {
        map = JSON.parse(mapEl.textContent || "{}");
      } catch (e) {
        return;
      }

      // Only update if this block belongs to this product (variant id exists in its map)
      if (!(variantId in map)) return;

      const label = (map[variantId] || "").trim();
      if (label) {
        headingEl.textContent = label;
        headingEl.hidden = false;
      } else {
        headingEl.textContent = "";
        headingEl.hidden = true;
      }
    });
  }

  function tick() {
    const candidate = getVariantIdFromUrl() || getVariantIdFromForms();
    if (candidate && candidate !== lastVariantId) {
      lastVariantId = candidate;
      applyVariantId(candidate);
    }
  }

  // 1) Ignite event (when it fires) :contentReference[oaicite:1]{index=1}
  document.addEventListener("variant-change", (event) => {
    const variant = event.detail && event.detail.variant;
    if (variant && variant.id) {
      lastVariantId = String(variant.id);
      applyVariantId(lastVariantId);
    }
  });

  // 2) Detect URL changes (?variant=...) even when AJAX updates history :contentReference[oaicite:2]{index=2}
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  function onLocationChange() {
    tick();
  }

  history.pushState = function () {
    _pushState.apply(this, arguments);
    onLocationChange();
  };
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    onLocationChange();
  };
  window.addEventListener("popstate", onLocationChange);

  // 3) Re-renders / sticky ATC insertion: watch DOM + keep a lightweight tick
  const mo = new MutationObserver(() => tick());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", () => {
    tick();
    setInterval(tick, 250);
  });
})();
